export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5106.02420b81.jpg";